import e from"./VoiceSearch.vue_vue&type=script&lang.js";import{render as r}from"./VoiceSearch.vue_vue&type=template&id=c25adbd0&lang.js";e.render=r;export default e;
//# sourceMappingURL=VoiceSearch.vue.js.map
